const QUEUE_KEY = "rubipos_queue";
const OFF_KEY = "rubipos_forced_offline";

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY)) || [];
  } catch {
    return [];
  }
}

export function setQueue(q) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
  window.dispatchEvent(new Event("rubipos-queue"));
}

export function enqueue(type, payload) {
  const q = getQueue();
  q.push({ uuid: crypto.randomUUID(), type, payload, created_at: new Date().toISOString() });
  setQueue(q);
  return q[q.length - 1].uuid;
}

export function isForcedOffline() {
  return localStorage.getItem(OFF_KEY) === "1";
}

export function setForcedOffline(v) {
  localStorage.setItem(OFF_KEY, v ? "1" : "0");
  window.dispatchEvent(new Event("rubipos-offline"));
}

export function isOffline() {
  return isForcedOffline() || !navigator.onLine;
}

export async function syncQueue(api) {
  const q = getQueue();
  if (!q.length) return { ok: true, synced: 0, failed: 0 };
  const { data } = await api.post("/sync/lote", { operaciones: q });
  const failed = new Set((data.resultados || []).filter((r) => !r.ok).map((r) => r.uuid));
  setQueue(q.filter((o) => failed.has(o.uuid)));
  return {
    ok: failed.size === 0,
    synced: (data.resultados || []).filter((r) => r.ok).length,
    failed: failed.size,
    resultados: data.resultados,
  };
}
